/**
 * The Products module's four sections.
 *
 * Its own file rather than an export beside the page component: a module that
 * exports both a component and a constant opts out of React Fast Refresh, and
 * `app-routes.tsx` needs these names to open the old `/categories` and
 * `/modifiers` links on the tab they used to mean.
 */
export const ProductsTab = {
  Products: 'products',
  Categories: 'categories',
  Brands: 'brands',
  ChoiceGroups: 'choice-groups',
  Options: 'options',
  Branches: 'branches',
} as const

export type ProductsTab = (typeof ProductsTab)[keyof typeof ProductsTab]
